import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import Paginator from "../../Common/Paginator";
import { getPMIXReport, changePMIXCategory } from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import PMIXTable from "./PMIXTable";
import {toast, ToastContainer} from 'react-toastify';

export default function PMIXHome() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get('restaurant_name');

  const [reports, setReports] = useState([]);
  const { loading, setLoading, pageSize, dateRange, reportType } = useAppStore();
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { id } = useParams();

  const fetchPMIXReport = () => {
    setLoading(true);
    getPMIXReport(pageNum, pageSize, id, dateRange, reportType)
      .then((data) => {
        setReports(data.pmix_report);
        setTotalPages(data.totalPages)
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  useEffect(() => {
    setLoading(true);
    getPMIXReport(pageNum, pageSize, id, dateRange, reportType)
      .then((data) => {
        setReports(data.pmix_report);
        setTotalPages(data.totalPages)
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, [pageNum, dateRange, reportType]);

  const handleCategoryChange = (pmix_id, category, subcategory) => {
    changePMIXCategory(pmix_id, category, subcategory)
      .then((data) => {
        toast.success(data.message);
        fetchPMIXReport();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <>
      <NavHeader view="scrapper" /> 
      <ToastContainer />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > PMIX Reports`} setPageIndex={setPageNum} />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <PMIXTable 
            reports={reports} 
            handleCategoryChange  = {handleCategoryChange} 
            restaurant_id={id}
            />
            <Paginator
              pageNum={pageNum}
              setPageNum={setPageNum}
              totalPages={totalPages}
            />
          </>
        )}
      </div>
    </>
  );
}
